var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AuditStatistics-layout"},[_c('div',{staticClass:"tip"},[_vm._v("程序开发中，敬请期待!")])])
}]

export { render, staticRenderFns }